exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app[data-v-7ba5bd90] {\n  min-height: 100vh;\n}\n.vue-notification[data-v-7ba5bd90] {\n  font-size: 35px;\n  text-align: center;\n  margin: 0;\n}\n", ""]);

// exports
